module.exports = __webpack_public_path__ + "img/face-recognition.6fb51fc1.svg";